if (!customElements.get("collapsible-text")) {
  customElements.define(
    "collapsible-text",
    class CollapsibleText extends HTMLElement {
      constructor() {
        super();

        this.hiddenContent = this.querySelector(".collapsible-text__content--hidden");
        this.button = this.querySelector("button");

        if (this.button) {
          this.button.addEventListener("click", this.toggleContent.bind(this));
        }
      }

      toggleContent() {
        this.hiddenContent.classList.toggle("opened");
        this.button.classList.toggle("opened");
      }
    },
  );
}
